module.exports = __webpack_public_path__ + "92620093effe4e20e9c60b62c6ba808d.png";